<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="监督对象:" prop="dwmc">
                        <el-input
                        v-model="queryParams.dwmc"
                        placeholder="请输入"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <!-- <el-form-item label="专业类别:" prop="zylb">
                        <el-select v-model="queryParams.zylb" placeholder="请选择专业类别" size="small">
                            <el-option
                                v-for="dict in zylbOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="案件来源:" >
                        <el-select v-model="queryParams.ajly" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in ajlyOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="上传日期:" >
                        <el-date-picker size="small" clearable
                            v-model="queryParams.startDate"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd" style="width:140px;">
                        </el-date-picker>
                        至
                        <el-date-picker size="small" clearable
                            v-model="queryParams.endDate"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd" style="width:140px;">
                        </el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item label="创建人:" prop="cjr">
                        <el-select v-model="queryParams.cjr" placeholder="请选择创建人" size="small" style="width:120px;">
                            <el-option
                                v-for="(dict,index) in userOptions"
                                :key="index"
                                    :label="dict.xm"
                                    :value="dict.xm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="档案状态:" prop="dazt">
                        <el-select v-model="queryParams.dazt" placeholder="请选择" size="small" style="width:120px;">
                            <el-option
                                v-for="dict in daztOptions"
                                :key="dict.id"
                                :label="dict.city"
                                :value="dict.city"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="主办人:" prop="zbr">
                        <el-select v-model="queryParams.zbr" placeholder="请选择主办人" size="small" style="width:120px;">
                            <el-option
                                v-for="(dict,index) in userOptions"
                                :key="index"
                                    :label="dict.xm"
                                    :value="dict.xm"
                                ></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                        <!-- <el-button type="danger" icon="el-icon-plus" size="small" @click="handleAdd">新增</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
                <p>案件数量:{{total}}</p>
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="dzdakList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="监督对象名称" prop="dwmc" key="dwmc" />
                    <el-table-column label="立案日期" align="center" prop="lian_rq" width="120" key="lian_rq" >
                        <template slot-scope="scope">
                            <span>{{getDate(scope.row.lian_rq,'yyyy-MM-dd')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="主办人" align="center" prop="host_man" width="90" key="host_man" />
                    <el-table-column label="协办人" align="center" prop="cooperate_man" width="90" key="cooperate_man" />
                    <el-table-column label="案由" align="center" prop="anyou" key="anyou" />
                    <el-table-column label="上传日期" align="center" prop="creattime" width="120" key="creattime" >
                        <template slot-scope="scope">
                            <span>{{getDate(scope.row.creattime,'yyyy-MM-dd')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="90">
                        <template slot-scope="scope">
                            <el-button
                            size="small"
                            type="text"
                            @click="handleSelect(scope.row)"
                        >查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            cmid:'',
            xianqu:'',
            queryParams:{
                dwmc:'',
                startDate:'',
                endDate:'',
                page:1,
                limit:10,
            },
            total:0,
            dzdakList:[],
            zylbOptions:[],
            ajlyOptions:[],
            userOptions:[],
            daztOptions:[],
            checkList:[],
            open:false,
            pageshow:true,
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.cmid = user.c_mid
        this.xianqu = user.xianqu
        this.baseUrl = user.baseUrl
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getZylb`,
            data:{
                 "cfxt":""
            },
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zylbOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        this.getList()
    },
    methods: {
        getList(){
            this.dzdakList = []
            this.total = 0
            axios({
                method: 'post',
                url: this.baseUrl+`/login/dzdaklist`,
                data:{
                    dwmc:this.queryParams.dwmc,
                    startDate:this.queryParams.startDate,
                    endDate:this.queryParams.endDate,
                    cmid:this.cmid,
                    limit:this.queryParams.limit,
                    page:this.queryParams.page
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                this.loading = false
                if(res.data.code == 0 && res.data.data){
                    this.dzdakList = res.data.data.list || []
                    this.total = res.data.data.total || 0
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.loading = false
                this.$message.error(error);
            })
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleAdd(){},
        getCheck(){
            console.log(this.checkList)
        },
        handleSelect(row){
            let obj = encodeURIComponent(JSON.stringify(row))
            console.log(obj)
            //if(this.xianqu == '上城区'){
            //    this.$router.push({
            //        name:'/daxq',
            //        params:{
            //            object:obj
            //        }
            //    })
            //}else{
                this.$router.push({
                    name:'/daxqYz',
                    params:{
                        object:obj
                    }
                })
            //}
//             // 序列化
// const serializedObject = encodeURIComponent(JSON.stringify(row));
 
//  // 传递序列化后的字符串
//  this.$router.push({ path: '/user', query: { object: serializedObject } });
  
//  // 在目标组件中反序列化接收的字符串
//  const receivedObject = JSON.parse(decodeURIComponent(this.$route.query.object));
        },
        resetQuery(){
            this.queryParams = {
                dwmc:'',
                startDate:'',
                endDate:'',
                page:1,
                limit:10,
            }
            this.getList()
        }
    }
}
</script>


<style scoped>
</style>